export const APP_LANGUAGE_STORAGE_KEY = 'app_language';

/** Landing page only — separate from logged-in app_language */
export const LANDING_LANGUAGE_STORAGE_KEY = 'landing_language';

export const SUPPORTED_LANGUAGES = ['sr', 'en'] as const;
export type AppLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export const DEFAULT_LANGUAGE: AppLanguage = 'sr';

export function normalizeLanguage(value: string | null | undefined): AppLanguage {
  const v = (value ?? '').trim().toLowerCase();
  if (v === 'en' || v.startsWith('en-') || v === 'english') return 'en';
  if (v === 'sr' || v.startsWith('sr-') || v === 'serbian' || v === 'srpski') return 'sr';
  return DEFAULT_LANGUAGE;
}

/** sr-Latn-RS: latinica (sr-RS u browseru često formatira datume ćirilicom). */
export function localeTagForLanguage(lang: AppLanguage): string {
  return lang === 'sr' ? 'sr-Latn-RS' : 'en-US';
}
